<template>
  <div class="date-range-picker w-100">
    <div class="row">
      <div :class="computedColClass" class="date-range-picker__start">
        <label class="col-form-label">
          {{ displayStartLabel }}
          <span v-if="required" class="required">*</span>
          <i v-if="startTooltip" :uk-tooltip="'title: ' + startTooltip" class="uil-info-circle"></i>
        </label>
        <VueCtkDateTimePicker v-model="localStartDate"
                              :format="computedFormat"
                              :only-date="!showTime"
                              :max-date="maxStartDate || undefined"
                              :min-date="minStartDate || undefined"
                              :no-label="true"
                              label=""
        />
      </div>
      <div :class="computedColClass" class="date-range-picker__end">
        <label class="col-form-label">
          {{ displayEndLabel }}
          <span v-if="required" class="required">*</span>
          <i v-if="endTooltip" :uk-tooltip="'title: ' + endTooltip" class="uil-info-circle"></i>
        </label>
        <VueCtkDateTimePicker v-model="localEndDate"
                              :format="computedFormat"
                              :only-date="!showTime"
                              :min-date="enforceMinEndDate && startDate ? startDate : minEndDate"
                              :no-button-now="true"
                              :no-label="true"
                              label=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateRangePicker",
  props: {
    startDate: {
      type: String,
      default: "",
    },
    endDate: {
      type: String,
      default: "",
    },
    minStartDate: {
      type: String,
      default: "",
    },
    maxStartDate: {
      type: String,
      default: "",
    },
    minEndDate: {
      type: String,
      default: "",
    },
    enforceMaxStartDate: {
      type: Boolean,
      default: false,
    },
    enforceMinEndDate: {
      type: Boolean,
      default: true,
    },
    startLabel: {
      type: String,
      default: "",
    },
    endLabel: {
      type: String,
      default: "",
    },
    startTooltip: {
      type: String,
      default: "",
    },
    endTooltip: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: "",
    },
    showTime: {
      type: Boolean,
      default: true,
    },
    layout: {
      type: String,
      default: "horizontal",
      validator: (value) => ["horizontal", "vertical"].includes(value),
    },
    colClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localStartDate: this.startDate,
      localEndDate: this.endDate,
    };
  },
  computed: {
    displayStartLabel() {
      return this.startLabel || this.$t('general.start_date');
    },
    displayEndLabel() {
      return this.endLabel || this.$t('general.end_date');
    },
    computedFormat() {
      if (this.format) {
        return this.format;
      }
      return this.showTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
    },
    computedColClass() {
      if (this.colClass) {
        return this.colClass;
      }
      if (this.layout === "vertical") {
        return "col-12";
      }
      return "col-12 col-md-6";
    },
  },
  watch: {
    startDate(newVal) {
      if (this.localStartDate !== newVal) {
        this.localStartDate = newVal;
      }
    },
    endDate(newVal) {
      if (this.localEndDate !== newVal) {
        this.localEndDate = newVal;
      }
    },
    localStartDate(newVal, oldVal) {
      if (this.startDate !== newVal) {
        this.$emit("update:startDate", newVal);
      }

      // Başlangıç tarihi bitiş tarihinden büyükse, bitiş tarihini güncelle
      if (newVal && this.localEndDate) {
        const startDate = new Date(newVal);
        const endDate = new Date(this.localEndDate);

        if (startDate > endDate) {
          this.localEndDate = newVal;
        }
      }
    },
    localEndDate(newVal) {
      if (this.endDate !== newVal) {
        this.$emit("update:endDate", newVal);
      }
    },
  },
};
</script>

<style scoped>
.date-range-picker__start,
.date-range-picker__end {
  margin-bottom: 15px;
}

/* Responsive: mobilde dikey, tablette ve üstünde yatay */
@media (min-width: 768px) {
  .date-range-picker__start,
  .date-range-picker__end {
    margin-bottom: 0;
  }
}

/* VueCtkDateTimePicker içindeki çarpı (clear) butonunu dikey ortala */
.date-range-picker >>> .field {
  display: flex;
  align-items: center;
}

.date-range-picker >>> .field .field-clear-button,
.date-range-picker >>> .field .clear {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 20%;
  transform: translateY(-50%);
}

.date-range-picker >>> .field-input {
  display: flex;
  align-items: center;
}
</style>
